import { render, staticRenderFns } from "./vsCheckbox.vue?vue&type=template&id=031018a3"
import script from "./vsCheckbox.vue?vue&type=script&lang=js"
export * from "./vsCheckbox.vue?vue&type=script&lang=js"
import style0 from "./vsCheckbox.vue?vue&type=style&index=0&id=031018a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports